module.exports = __webpack_public_path__ + "static/media/x.431ee5dd.svg";